import { DatePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ICampaignGlobalWinner } from 'core';
import { AvatarService } from 'core/services/avatar.service';
import { KorviuLoaderComponent, KorviuNoDataComponent } from 'shared';

interface IRecentPromotionWinnerView extends ICampaignGlobalWinner {
  avatarUrl: string | null;
}

@Component({
  selector: 'app-recent-promotion-winners',
  imports: [DatePipe, KorviuLoaderComponent, KorviuNoDataComponent, RouterLink, TranslatePipe],
  templateUrl: './recent-promotion-winners.component.html',
  styleUrl: './recent-promotion-winners.component.scss'
})
export class RecentPromotionWinnersComponent {
  readonly #avatarService = inject(AvatarService);

  readonly winners = input<ICampaignGlobalWinner[]>([]);
  readonly isLoading = input<boolean>(false);
  readonly winnerRows = computed<IRecentPromotionWinnerView[]>(() =>
    this.winners().map(winner => ({
      ...winner,
      avatarUrl: winner.participant.avatar ? this.#avatarService.getUserAvatar(winner.participant.avatar) : null
    }))
  );
}
